import { getCurrentUser } from "aws-amplify/auth";
import { usePiniaStore } from "@/stores/store";

async function authGuard(to, _from) {
    const pStore = usePiniaStore();

    /** If the user tries to navigate to /, skip the guard check */
    if (to.path === "/") {
        return true;
    }

    try {
        /** Attempt to get the authenticated user */
        const { userId } = await getCurrentUser();

        if (userId) {
            /** User is authenticated, proceed to the route */
            pStore.setIsAuthenticated(true);
        } else {
            pStore.setIsAuthenticated(false);
            return "/unauthorised-access";
        }
    } catch (error) {
        pStore.setIsAuthenticated(false);

        return { path: "/", query: { origin: to.fullPath } };
    }
}

export default authGuard;
